import { create } from "zustand";
import { ReferralEarning } from "../api/types";

interface ReferralEarningsState {
  // Data
  earnings: ReferralEarning[];
  totalXp: number;
  totalReferrals: number;
  hasMore: boolean;
  currentOffset: number;

  // Loading states
  isLoading: boolean;
  isLoadingMore: boolean;

  // Error state
  error: string | null;

  // Internal methods (prefixed with _)
  _setEarnings: (earnings: ReferralEarning[]) => void;
  _appendEarnings: (earnings: ReferralEarning[]) => void;
  _setTotalXp: (totalXp: number) => void;
  _setTotalReferrals: (totalReferrals: number) => void;
  _setHasMore: (hasMore: boolean) => void;
  _setCurrentOffset: (offset: number) => void;
  _setLoading: (loading: boolean) => void;
  _setLoadingMore: (loading: boolean) => void;
  _setError: (error: string | null) => void;
  _reset: () => void;
}

const initialState = {
  earnings: [],
  totalXp: 0,
  totalReferrals: 0,
  hasMore: false,
  currentOffset: 0,
  isLoading: false,
  isLoadingMore: false,
  error: null,
};

export const useReferralEarningsStore = create<ReferralEarningsState>(
  (set) => ({
    ...initialState,

    // Setters
    _setEarnings: (earnings) => set({ earnings }),
    _appendEarnings: (newEarnings) =>
      set((state) => ({ earnings: [...state.earnings, ...newEarnings] })),
    _setTotalXp: (totalXp) => set({ totalXp }),
    _setTotalReferrals: (totalReferrals) => set({ totalReferrals }),
    _setHasMore: (hasMore) => set({ hasMore }),
    _setCurrentOffset: (currentOffset) => set({ currentOffset }),
    _setLoading: (isLoading) => set({ isLoading }),
    _setLoadingMore: (isLoadingMore) => set({ isLoadingMore }),
    _setError: (error) => set({ error }),
    _reset: () => set(initialState),
  })
);
